import { N8nTrackMapOutline } from '@shared/models/n8n-track-map-outline.model';

export interface TrackSvg {
    pathLeft: string;
    pathRight: string;
    viewBox: string;
}

export function svgPointsToPath(points: string): string {
    if (!points) return '';
    const pairs = points.trim().split(/\s+/);
    if (!pairs.length || !pairs[0]) return '';
    return pairs.map((p, i) => `${i === 0 ? 'M' : 'L'}${p}`).join(' ');
}

/**
 * Eine Outline ohne Pfade ist keine Karte. `buildTrackSvg` liefert in dem Fall ein Objekt mit
 * leeren Pfaden, das truthy ist — ohne diese Prüfung landet ein leeres `<svg>` in der Seite
 * statt des Hinweises „Keine Streckenkarte".
 */
export function hasTrackSvgPaths(svg: TrackSvg): boolean {
    return !!svg.pathLeft || !!svg.pathRight;
}

export function buildTrackSvg(outline: N8nTrackMapOutline): TrackSvg {
    if (!outline.outlineLeftSvgPoints && !outline.outlineRightSvgPoints) {
        return { pathLeft: '', pathRight: '', viewBox: '0 0 1000 1000' };
    }
    return {
        pathLeft: svgPointsToPath(outline.outlineLeftSvgPoints),
        pathRight: svgPointsToPath(outline.outlineRightSvgPoints),
        viewBox: outline.svgViewBox || '0 0 1000 1000',
    };
}
